import { render, staticRenderFns } from "./franchise.vue?vue&type=template&id=6998ddff&scoped=true&"
import script from "./franchise.vue?vue&type=script&lang=js&"
export * from "./franchise.vue?vue&type=script&lang=js&"
import style0 from "./franchise.vue?vue&type=style&index=0&id=6998ddff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6998ddff",
  null
  
)

component.options.__file = "franchise.vue"
export default component.exports